import React__default from 'react';
import { ButtonIcon } from './ButtonIcon.js';
function ButtonContent(props) {
  var leftIcon = props.leftIcon,
    rightIcon = props.rightIcon,
    children = props.children,
    iconSpacing = props.iconSpacing;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, leftIcon && /*#__PURE__*/React__default.createElement(ButtonIcon, {
    marginEnd: iconSpacing
  }, leftIcon), children, rightIcon && /*#__PURE__*/React__default.createElement(ButtonIcon, {
    marginStart: iconSpacing
  }, rightIcon));
}
export { ButtonContent };